(function () {
  'use strict';

  /* ── helpers ── */
  function money(cents) {
    var f = window.themeMoneyFormat || '${{amount}}';
    return f.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
  }
  function sha256hex(str) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str))
      .then(function (buf) {
        return Array.prototype.map.call(new Uint8Array(buf), function (b) {
          return b.toString(16).padStart(2, '0');
        }).join('');
      });
  }
  function openLayer(panel, scrim) {
    panel.classList.add('is-on');
    panel.setAttribute('aria-hidden', 'false');
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('is-on'); });
  }
  function closeLayer(panel, scrim) {
    panel.classList.remove('is-on');
    panel.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-on');
    setTimeout(function () { scrim.hidden = true; }, 300);
  }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── drop gate ── */
  var gate = document.getElementById('DropGate');
  if (gate) {
    var gateHash = gate.dataset.hash;
    if (localStorage.getItem('empyreal_gate') === gateHash) {
      gate.remove();
    } else {
      document.body.classList.add('is-gated');
      var gForm = document.getElementById('GateForm');
      var gErr = document.getElementById('GateErr');
      if (gForm) gForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var val = document.getElementById('GateInput').value || '';
        sha256hex(val.trim()).then(function (h) {
          if (h === gateHash) {
            localStorage.setItem('empyreal_gate', h);
            gate.classList.add('is-off');
            document.body.classList.remove('is-gated');
            setTimeout(function () { gate.remove(); }, 420);
          } else if (gErr) {
            gErr.hidden = false;
          }
        });
      });
    }
  }

  /* ── seamless: image fade-in ── */
  document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    img.decoding = 'async';
    if (img.complete) return;
    img.style.opacity = '0';
    img.style.transition = 'opacity .45s ease';
    img.addEventListener('load', function () {
      requestAnimationFrame(function () { img.style.opacity = ''; });
    }, { once: true });
    img.addEventListener('error', function () { img.style.opacity = ''; }, { once: true });
  });

  /* ── seamless: scroll reveal ── */
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll(
      '.card, .tile, .det__cell, .ig__cell, .look__item, .news__h, .news__form'
    );
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('rv-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    var batch = 0;
    targets.forEach(function (el, i) {
      el.classList.add('rv');
      el.style.transitionDelay = (i % 6) * 45 + 'ms';
      io.observe(el);
    });
  }

  /* ── seamless: hover prefetch ── */
  var prefetched = {};
  function prefetch(url) {
    if (prefetched[url]) return;
    prefetched[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    document.head.appendChild(l);
  }
  ['mouseover', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var a = e.target.closest && e.target.closest('a[href^="/"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.length < 2) return;
      if (/^\/(cart|checkout|account|search)/.test(href)) return;
      prefetch(href);
    }, { passive: true });
  });

  /* ── seamless: header hide on scroll ── */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var lastY = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var anyOpen = document.querySelector('.cdrawer.is-on, .mdrawer.is-on, .sov.is-on');
        if (!anyOpen) {
          if (y > 90 && y > lastY + 4) hdr.classList.add('is-hidden');
          else if (y < lastY - 4 || y <= 90) hdr.classList.remove('is-hidden');
        }
        lastY = y;
        ticking = false;
      });
    }, { passive: true });
  }

  /* ── rotating announcements ── */
  var ann = document.getElementById('Announce');
  if (ann) {
    var msgs = ann.querySelectorAll('.announce__m');
    if (msgs.length > 1 && !reduceMotion) {
      var ai = 0;
      setInterval(function () {
        ai = (ai + 1) % msgs.length;
        msgs.forEach(function (m, n) { m.classList.toggle('is-on', n === ai); });
      }, 4000);
    }
  }

  /* ── mobile menu ── */
  var mDrawer = document.getElementById('MenuDrawer');
  var mScrim = document.getElementById('MenuScrim');
  var mOpen = document.getElementById('MenuOpen');
  var mClose = document.getElementById('MenuClose');
  if (mDrawer && mScrim) {
    if (mOpen) mOpen.addEventListener('click', function () { openLayer(mDrawer, mScrim); });
    if (mClose) mClose.addEventListener('click', function () { closeLayer(mDrawer, mScrim); });
    mScrim.addEventListener('click', function () { closeLayer(mDrawer, mScrim); });
  }

  /* ── cart drawer ── */
  var cDrawer = document.getElementById('CartDrawer');
  var cScrim = document.getElementById('Scrim');
  var cBody = document.getElementById('DrawerBody');
  var cSub = document.getElementById('DrawerSubtotal');
  var cCount = document.getElementById('CartCount');
  var bagLink = document.getElementById('BagOpen');
  var dClose = document.getElementById('DrawerClose');
  var shipWrap = document.querySelector('.ship');
  var shipText = document.getElementById('ShipText');
  var shipFill = document.getElementById('ShipFill');
  var lastCount = cCount ? +cCount.textContent : 0;

  function renderShip(total) {
    if (!shipWrap || !shipText || !shipFill) return;
    var threshold = +shipWrap.dataset.threshold || 0;
    if (!threshold) return;
    var pct = Math.min(100, (total / threshold) * 100);
    shipFill.style.width = pct + '%';
    if (total >= threshold) {
      shipText.innerHTML = '<b>Free shipping unlocked</b>';
    } else {
      shipText.innerHTML = "You're <b>" + money(threshold - total) + '</b> away from free shipping';
    }
  }

  function renderCart(cart) {
    if (cCount) {
      cCount.textContent = cart.item_count;
      if (cart.item_count !== lastCount && bagLink && !reduceMotion) {
        bagLink.classList.remove('is-bump');
        void bagLink.offsetWidth;
        bagLink.classList.add('is-bump');
      }
      lastCount = cart.item_count;
    }
    if (cSub) cSub.textContent = money(cart.total_price);
    renderShip(cart.total_price);
    if (!cBody) return;
    var keep = cBody.scrollTop;
    if (!cart.items.length) {
      cBody.innerHTML = '<p class="empty">Your bag is empty</p>';
      return;
    }
    cBody.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" width="64" height="80">'
        : '<div class="dline__ph"></div>';
      var variant = item.variant_title
        ? '<div class="dline__m">' + item.variant_title + '</div>' : '';
      return '<div class="dline">' + img +
        '<div class="dline__mid"><div class="dline__n">' + item.product_title + '</div>' + variant +
        '<div class="dline__q">' +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div></div>' +
        '<div class="dline__p">' + money(item.final_line_price) + '</div></div>';
    }).join('');
    cBody.scrollTop = keep;
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function openCart() {
    if (!cDrawer || !cScrim) return;
    openLayer(cDrawer, cScrim);   /* open instantly, fill as data lands */
    refreshCart();
  }

  if (cDrawer && cScrim) {
    if (bagLink) bagLink.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
    if (dClose) dClose.addEventListener('click', function () { closeLayer(cDrawer, cScrim); });
    cScrim.addEventListener('click', function () { closeLayer(cDrawer, cScrim); });
    if (cBody) cBody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b || b.disabled) return;
      b.parentElement.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.q })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function () { refreshCart(); });
    });
  }

  /* ── quick add on cards ── */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-qa-id]');
    if (!qa) return;
    e.preventDefault();
    var label = qa.textContent;
    qa.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: +qa.dataset.qaId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        qa.textContent = 'Added';
        openCart();
        setTimeout(function () { qa.textContent = label; }, 1400);
      })
      .catch(function () {
        window.location.href = qa.dataset.href || '/';
      });
  });

  /* ── predictive search ── */
  var sOv = document.getElementById('SearchOverlay');
  var sScrim = document.getElementById('SearchScrim');
  var sOpen = document.getElementById('SearchOpen');
  var sClose = document.getElementById('SearchClose');
  var sInput = document.getElementById('SearchInput');
  var sResults = document.getElementById('SearchResults');
  var sTimer = null, sSeq = 0;

  function searchRender(products, q) {
    if (!products.length) {
      sResults.innerHTML = '<p class="sov__none">Nothing for \u201c' + q.replace(/</g, '&lt;') + '\u201d</p>';
      return;
    }
    sResults.innerHTML = products.map(function (p) {
      var img = p.image
        ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=100" alt="" width="44" height="55">'
        : '<span class="sres__ph"></span>';
      var cents = Math.round(parseFloat(p.price) * 100);
      var price = isNaN(cents) ? '' : money(cents);
      return '<a class="sres" href="' + p.url + '">' + img +
        '<span class="sres__n">' + p.title + '</span>' +
        '<span class="sres__p">' + price + '</span></a>';
    }).join('') +
    '<a class="sov__all" href="/search?q=' + encodeURIComponent(q) + '">View all results</a>';
  }

  if (sOv && sScrim && sInput) {
    if (sOpen) sOpen.addEventListener('click', function (e) {
      e.preventDefault();
      openLayer(sOv, sScrim);
      setTimeout(function () { sInput.focus(); }, 200);
    });
    if (sClose) sClose.addEventListener('click', function () { closeLayer(sOv, sScrim); });
    sScrim.addEventListener('click', function () { closeLayer(sOv, sScrim); });

    sInput.addEventListener('input', function () {
      var q = sInput.value.trim();
      clearTimeout(sTimer);
      if (q.length < 2) { sResults.hidden = true; return; }
      sTimer = setTimeout(function () {
        var seq = ++sSeq;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (seq !== sSeq) return; /* stale response */
            var products = (((data || {}).resources || {}).results || {}).products || [];
            sResults.hidden = false;
            searchRender(products, q);
          })
          .catch(function () {});
      }, 220);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cDrawer && cScrim) closeLayer(cDrawer, cScrim);
    if (mDrawer && mScrim) closeLayer(mDrawer, mScrim);
    if (sOv && sScrim) closeLayer(sOv, sScrim);
  });

  /* ── slideshow (with touch swipe) ── */
  document.querySelectorAll('.slideshow').forEach(function (show) {
    var slides = show.querySelectorAll('.slide');
    if (slides.length < 2) return;
    var dots = show.querySelectorAll('.dots button');
    var idx = 0, timer = null, touchX = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-on', n === idx); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', String(n === idx)); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { go(i); stop(); });
    });
    show.addEventListener('touchstart', function (e) {
      touchX = e.changedTouches[0].clientX;
    }, { passive: true });
    show.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 42) return;
      go(dx < 0 ? idx + 1 : idx - 1);
      stop();
    }, { passive: true });

    if (show.dataset.autoplay === 'true' && !reduceMotion) {
      timer = setInterval(function () { go(idx + 1); }, 6000);
    }
  });

  /* ── product page ── */
  var main = document.getElementById('PdpMain');
  document.querySelectorAll('.pdp__thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.src = t.dataset.full;
      document.querySelectorAll('.pdp__thumb').forEach(function (x) { x.classList.remove('is-on'); });
      t.classList.add('is-on');
    });
  });

  var raw = document.getElementById('VariantJson');
  var form = document.getElementById('ProductForm');
  if (!raw || !form) return;

  var variants;
  try { variants = JSON.parse(raw.textContent); } catch (e) { return; }

  var idField = document.getElementById('VariantId');
  var priceEl = document.getElementById('PdpPrice');
  var addBtn = document.getElementById('AddBtn');
  var satcBtn = document.getElementById('SatcBtn');
  var satcPrice = document.getElementById('SatcPrice');
  var groups = form.querySelectorAll('.opt');

  function chosen() {
    return Array.prototype.map.call(groups, function (g) {
      var hit = g.querySelector('.opt__in:checked');
      return hit ? hit.value : null;
    });
  }
  function findVariant(picked) {
    return variants.find(function (v) {
      return picked.every(function (val, i) { return val === null || v.options[i] === val; });
    });
  }
  function greyOut(picked) {
    groups.forEach(function (g, gi) {
      g.querySelectorAll('.opt__in').forEach(function (input) {
        var test = picked.slice();
        test[gi] = input.value;
        var hit = findVariant(test);
        input.disabled = !(hit && hit.available);
      });
    });
  }
  function setAdd(disabled, label) {
    addBtn.disabled = disabled;
    addBtn.textContent = label;
    if (satcBtn) { satcBtn.disabled = disabled; satcBtn.textContent = label; }
  }
  function sync() {
    var picked = chosen();
    var v = findVariant(picked);
    greyOut(picked);
    if (!v) { setAdd(true, 'Unavailable'); return; }
    if (idField) idField.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (satcPrice) satcPrice.textContent = money(v.price);
    setAdd(!v.available, v.available ? 'Add to bag' : 'Sold out');
    var url = new URL(window.location);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  }
  form.addEventListener('change', function (e) {
    if (e.target.classList.contains('opt__in')) sync();
  });
  sync();

  if (satcBtn) satcBtn.addEventListener('click', function () {
    if (form.requestSubmit) form.requestSubmit();
    else form.submit();
  });

  var ajaxFailed = false;
  form.addEventListener('submit', function (e) {
    if (!cDrawer || ajaxFailed) return;
    e.preventDefault();
    setAdd(true, 'Adding\u2026');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        setAdd(true, 'Added');
        openCart();
        setTimeout(sync, 900);
      })
      .catch(function () {
        ajaxFailed = true;
        form.submit();
      });
  });
})();
